<template>
    <div class="name-wrapper">
        <div class="content">

            <mobile-header>
                <i slot="arrowLeft" class="el-icon-arrow-left" @click="$emit('hideName')"></i> <!-- 旧语法 -->
                <span slot="title" class="text">设置名字</span> <!-- 旧语法 -->
                <span slot="button" class="button" @click="updateNickName">完成</span>
            </mobile-header>

            <el-input v-model="name"></el-input>

            <!-- <div class="edit-btn">
                确定
            </div> -->
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex';
import { updateNickName } from '@/api/home';
import MobileHeader from './MobileHeader.vue';

export default {
    name: 'avatar',
    components: {
        MobileHeader,
    },
    data() {
        return {
            name: ""
            // data properties
        }
    },
    computed: {
        ...mapState(["user"])
    },
    mounted() {
        this.name = this.user.name
        // lifecycle hook
    },
    methods: {
        // methods
        async updateNickName() {
            let nickname = this.name
            if(!nickname) {
                this.$message.warning("昵称不能为空")
                return
            }
            let res = await updateNickName({ nickname });
            // this.nicknameDialogVisible = false
            this.$emit('hideName')
            if (!res) return;
            if (res.status === 200) {
                this.$message.success(res.data.message)
                this.$store.commit("setUser", { name: nickname })
            } else {
                this.$message.error("更新昵称失败！")
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.name-wrapper {
    /* styles */
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 10px;
    width: calc(100vw - 20px);
    height: 100vh;
    background-color: var(--mobile-bg-color);
    z-index: 100;
    text-align: center;


 

    .edit-btn {
        margin: 0 auto;
        margin-top: 30px;
        width: 50%;
        line-height: 3;
        font-size: 14px;
        background-color: $second_blue;
        color: #fff;
        text-align: center;
        border-radius: 60px;
    }

}

::v-deep .el-input__inner {
    color: var(--txt-default-color);
    background-color: var(--main-color, #434346);
}

@media (min-width: 750px) {
    .content{
        margin: 0 calc((100vw - 750px) / 2);
    }
}
</style>